// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "ponto-acao-876c1.firebaseapp.com",
  "projectId": "ponto-acao-876c1",
  "storageBucket": "ponto-acao-876c1.appspot.com",
  "messagingSenderId": "224225714641",
  "appId": "1:224225714641:web:b0e4b415c3933660b280f0",
  "measurementId": "G-M1R77SQPF2",
  "apiKey": "AIzaSyBjKBQOm1BaVvv3j7zBNXeXHP23y-1QN9c"
};
